<template>
  <el-form
    :model="OrderForm"
    :rules="rules"
    ref="ruleForm"
    label-width="150px"
    class="demo-ruleForm"
  >
    <el-form-item label="访客姓名" prop="name" >
      <el-input v-model="OrderForm.name" style="width: 200px;"></el-input>
    </el-form-item>
    <el-form-item label="性别" prop="sex">
      <el-select v-model="OrderForm.sex" placeholder="请选择性别" style="width: 200px;">
        <el-option label="男" value="男"></el-option>
        <el-option label="女" value="女"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="拜访开始时间" required>
      <el-col :span="5">
        <el-form-item prop="date1">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="OrderForm.date1"
            style="width: 85%"
          ></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col class="line" :span="1">-</el-col>
      <el-col :span="5">
        <el-form-item prop="date2">
          <el-time-picker
            placeholder="选择时间"
            v-model="OrderForm.date2"
            style="width: 85%"
          ></el-time-picker>
        </el-form-item>
      </el-col>
    </el-form-item>
    <el-form-item label="拜访结束时间" required>
      <el-col :span="5">
        <el-form-item prop="date3">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="OrderForm.date3"
            style="width: 85%"
          ></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col class="line" :span="1">-</el-col>
      <el-col :span="5">
        <el-form-item prop="date4">
          <el-time-picker
            placeholder="选择时间"
            v-model="OrderForm.date4"
            style="width: 85%"
          ></el-time-picker>
        </el-form-item>
      </el-col>
    </el-form-item>
    <el-form-item label="手机号" prop="phone">
      <el-input v-model="OrderForm.phone" style="width: 400px;"></el-input>
    </el-form-item>
    <el-form-item label="证件号码" prop="idc">
      <el-input v-model="OrderForm.idc" style="width: 400px;"></el-input>
    </el-form-item>
    <el-form-item label="来访单位" prop="units">
        <el-input v-model="OrderForm.units" style="width: 400px;"></el-input>
      </el-form-item>
    <el-form-item label="拜访事由" prop="text">
      <el-input v-model="OrderForm.text" style="width: 400px;"></el-input>
    </el-form-item>
    <el-form-item label="车牌号码" prop="car">
      <el-input v-model="OrderForm.car" style="width: 400px;"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="referForm">保存</el-button>
      <el-button @click="resetForm">重置</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      OrderForm: {
        name: "",
        sex: "",
        date1: "",
        date2: "",
        date3: "",
        date4: "",
        units:"",
        text:"",
        phone: "",
        idc: "",
        car:""
      },
      rules: {
        name: [
          { message: "请输入姓名", trigger: "blur" ,required: true,},
          {
            pattern: /^[\u4e00-\u9fa5]{2,10}$/,
            message: "姓名格式不正确",
            trigger: "blur",
          },
        ],
        phone: [
          {required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
        idc: [
          {message: "请输入身份证号", trigger: "blur" },
          {
            pattern:
              /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))((0[1-9])|([12][0-9])|3[01])\d{3}[Xx\d]$/,
            message: "身份证号格式不正确",
            trigger: "blur",
          },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        date1: [{ required: true, message: "请选择日期", trigger: "change" }],
        date2: [{ required: true, message: "请选择时间", trigger: "change" }],
      },
    };
  },
  methods: {
    fetch() {
      if (this.$route.params && this.$route.params.id) {
        const id = this.$route.params.id;
        this.$http
          .get(`OrderForm/${id}`)
          .then((res) => {
            this.OrderForm = res;
          })
          .catch((error) => {
            console.error("获取人员信息失败:", error);
            this.$message.error("人员信息获取失败，请重试");
          });
      } else {
        console.error("路由参数中缺少 id");
        this.$message.error("缺少必要的路由参数，请检查链接");
      }
    },
    referForm() {
        const id = this.$route.params.id;
      this.$http.put(`OrderForm/${id}`, this.OrderForm)
   .then((res) => {
        console.log('请求成功，响应数据:', res); // 打印完整的响应对象
        this.$message({
            message: "人员编辑成功",
            type: "success",
        });
        this.$router.push('/order/list');
    })
   .catch((err) => {
        console.error('请求失败，错误信息:', err); // 打印错误信息
        this.$message.error("人员编辑失败，请重试");
    });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
  },
  created() {
    this.fetch();
  },
};
</script>
